import Store from '@ember-data/store';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import CurrentUser from 'donor-elf-web/services/current-user';

export default class IntervarsityFirstImportController extends Controller {
  @service declare currentUser: CurrentUser;
  @service declare store: Store;

  @action
  async checkForImportComplete() {
    let user = await this.store.findRecord('user', this.currentUser.id!, {
      reload: true,
    });
    // the import is complete when afterLoginRoute is empty
    if (isEmpty(user.afterLoginRoute)) {
      window.location.reload();
    }
  }
}
